import { createActions } from 'reduxsauce';

import API from '../../api';
import AuthService from '../../services/authService';


const { Types, Creators } = createActions({
  getMySavedOrdersSuccess: ['orders', 'nextCursor', 'isOverwrite', 'totalOrders'],
  getMySavedOrdersFailure: ['errorMessage'],
  getMySavedOrdersRequest: (queryParams) => async (dispatch) => {
    try {
      const userId = AuthService.getUserId();

      if (!userId) {
        dispatch(Creators.getMySavedOrdersFailure('USERID_NOT_FOUND'));
        return;
      }

      const response = await API.orders.list.savedByUserId(userId, queryParams);
      const { ok, problem, data } = response || {};
      const error = data?.error || {};
      const orders = response?.data?.orders || [];
      const next = response?.data?.nextCursor || '';
      const isOverwrite = response?.data?.isOverwrite;
      const totalOrders = response?.data?.totalOrders;
      const errorMessage = !ok
        ? (error?.message || data?.message || problem)
        : '';

      if (errorMessage) {
        dispatch(Creators.getMySavedOrdersFailure(errorMessage));
        return;
      }

      dispatch(Creators.getMySavedOrdersSuccess(orders, next, isOverwrite, totalOrders));
    } catch (error) {
      dispatch(Creators.getMySavedOrdersFailure(error.message || error.reason));
    }
  },

  clearSavedOrders: null,

  togglePutOrderIntoWorkModal: ['isOpen'],

  toggleDeleteOrderModal: ['isOpen'],

  toggleCopyOrderModal: ['isOpen'],

  toggleChangePriceModal: ['isOpen'],
});

export const MySavedOrdersTypes = Types;
export default Creators;
